<section id="landing-features">
  <div class="content">
      <div class="top">
        <h2 class="title">What ENL provides</h2>
      </div>
      <div class="feature-container">
        <div class="feature first">
          <div class="feature-content-container">
            <div class="feature-content">
          <div class="feature-number">1</div>
            <h3 class="feature-title">Increased Transparency.</h3>
            <div class="feature-divider"></div>
            <ul>
              <li>Searchable schedules from over 20 Ro-Ro lines in one place.</li>
              <li>Planned and actual PCTC/Ro-Ro vessel port calls in over 500 ports worldwide.</li>
              <li>Advanced algorithms are combining planned, actual schedule and AIS information to predict vessel arrival at destination.</li>
            </ul>
          </div>
            <img class="media" src="../../../../assets/images/features/search.jpg" />
          </div>
        </div>
      </div>

        <div class="feature flipped">
          <div class="feature-content-container">
            <img class="media" src="../../../../assets/images/features/scheduleSearch.jpg" />
            <div class="feature-content">
              <div class="feature-number">2</div>
              <h3 class="feature-title">Increased efficiency.</h3>
              <div class="feature-divider"></div>
              <ul>
                <li>Save hours/days finding a transport solution.</li>
                <li>Plan better with full overview of planned and actual port movements.</li>
                <li>Organize the inland transportation with better information on vessel arrivals.</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="feature">
          <div class="feature-content-container">
            <div class="feature-content">
              <div class="feature-number">3</div>
              <h3 class="feature-title">Increased Profitability.</h3>
              <div class="feature-divider"></div>
              <ul>
                <li>Finding the optimal solution for your transport needs</li>
                <li>By examining all schedules, the system will show transhipment solutions the market does not know about, increasing the potential for capturing new clients and new cargo.</li>
                <li>Save cost and increase competitiveness by acting on the increased transparency created by ENL Solutions.</li>
              </ul>
            </div>
            <img class="media" src="../../../../assets/images/features/nfn.jpg" />
          </div>
        </div>

      </div>
</section>
